import { Card, Heading, Markdown } from '@frontendmentorio/design-system-v2';

export default function Ideas({ challenge }) {
  return (
    <Card className="flex flex-col gap-4 p-5">
      <Heading className="flex gap-2" level="4" tagName="h2">
        <span>💡</span>
        Ideas to test yourself
      </Heading>

      {typeof challenge.ideas === 'string' ? (
        <Markdown>{challenge.ideas}</Markdown>
      ) : (
        <ol className="flex flex-col gap-2">
          {challenge.ideas.map((idea, index) => (
            <li key={index}>
              <Markdown>{idea}</Markdown>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
